<template>
  <div class="warp" v-loading="loading">
    <div class="warp-content">
      <div class="left">
        <div class="chunk-title">场地列表</div>
        <div class="flex-1">
          <el-tree ref="tree" highlight-current :data="treeAreaData" node-key="id" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
        </div>
      </div>
      <div class="right">
        <div class="chunk-title">
          <time-search ref="timeSearch" :control="{data:timeData}" @timeControlChange="timeControlChange" @timeControlClick="TimeControlClick" :showExportBtn="true" @exportExc="bindExportExc">
            <span class="typetext" style="padding-left:10px;">能源类型：</span>
            <el-select size="small" style="width:150px;" v-model="dataType" v-if="energyType">
              <el-option v-for="(item,index) in energyType" :key="index" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </time-search>
        </div>
        <div class="flex-1">
          <nk-table id="table" :data="totalTableData" :noDataTitle="'该时间段暂无数据'" :columns="columns">
          </nk-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  exportExcel
} from '@/utils/index.js'
import api from '@common/api/index.js'
import utils from '@common/utils/index.js'
import Tree from "@/utils/tree.js";
import dateTool from "@/utils/dateTool.js"
import config from "@common/config/index.js"
import TimeSearch from '@/components/common/TimeSearch.vue'
import NkTable from '@/components/common/NkTable'
import tmp from '@common/utils/tmp.js'
let allTimeData = [
  {
    type: 'day',
    label: '日',
  },
  {
    type: 'month',
    label: '月',
  },
  {
    type: 'year',
    label: '年',
  },
]
export default {
  components: { TimeSearch, NkTable },
  data () {
    return {
      timeData: allTimeData,
      energyType: [{ id: 1, label: '电' }, { id: 2, label: '水' }, { id: 3, label: '天然气' }, { id: 4, label: '柴油' }],
      selectedDate: {
        dateType: 'day',
        endTime: null,
        startTime: null,
      },
      dataType: 1,// 默认为电
      tableData: [],
      proprietorIndex: 0,
      treeAreaData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      selectedArea: null,
      switchData: [],
      socket: null,
      loading: false,
      totalTableData: [],
      columns: [
        { prop: "name", label: "场地名称", show: true },
        { prop: "measureId", label: "表号", show: true },
        { prop: "startMeasuringValue", label: "开始表码", show: true },
        { prop: "startTime", label: "开始时间", show: true },
        { prop: "endMeasuringValue", label: "结束表码", show: true },
        { prop: "endTime", label: "结束时间", show: true },
        { prop: "quantity", label: "用量", show: true },
      ],
    }
  },
  created () {
    let time = new Date()
    let startTime = dateTool.format(time, 'yyyy/MM/dd') + ' 00:00:00'
    time.setDate(time.getDate() + 1)
    let endTime = dateTool.format(time, 'yyyy/MM/dd') + ' 00:00:00'

    this.selectedDate = {
      dateType: 'day',
      startTime: startTime,
      endTime: endTime
    }
    this.getRentalArea()
  },
  methods: {
    getRentalArea () {
      api.rentalArea.getRentalArea(0).then(res => {
        if (res.data) {
          this.treeAreaData = utils.companyDataToCompanyTree(res.data)
          if (this.treeAreaData.length > 0) {
            this.selectedArea = this.treeAreaData[0]
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(this.selectedArea.id)
            })
            this.getRentalAreaEnergyCost()
          }
        }
        else {
          this.treeAreaData = []
          this.selectedArea = null
        }
      })
    },
    handleNodeClick (data, nodde, el) {
      this.selectedArea = data
      this.getRentalAreaEnergyCost()
    },
    timeControlChange () {
    },
    //查询事件
    TimeControlClick (e) {
      let vm = this
      vm.selectedDate = e
      vm.selectedDate.dataType = vm.dataType
      this.getRentalAreaEnergyCost()
    },

    getRentalAreaEnergyCost () {
      let areaArr = Tree.treeArrToArr([this.selectedArea])
      let areas = []
      let areaIds = []
      for (let i = 0; i < areaArr.length; i++) {
        areaIds.push(areaArr[i].id)
        areas.push({ id: areaArr[i].id, name: areaArr[i].name })
      }


      let apiFuncName = null
      switch (this.selectedDate.dateType) {
        case 'day':
          apiFuncName = 'getRentalAreaEnergyCostDay'
          break;
        case 'month':
          apiFuncName = 'getRentalAreaEnergyCostMonth'
          break;
        case 'year':
          apiFuncName = 'getRentalAreaEnergyCostYear'
          break;
      }
      api.rentalArea[apiFuncName](areaIds, this.dataType, this.selectedDate.startTime, this.selectedDate.endTime).then(res => {
        let tableData = []
        if (res.data) {
          let resData = res.data
          for (let i = 0; i < resData.length; i++) {
            let name = '-'
            const areaItem = areas.find(c => c.id == resData[i][0].id)
            name = areaItem.name
            if (resData[i][0].energy && resData[i][0].energy.length > 0) {
              const energy = resData[i][0].energy[0]
              if (energy.measuringBasic.length == 0) {
                tableData.push({
                  name: name,
                  measureId: '-',
                  startTime: '-',
                  startMeasuringValue: '-',
                  endTime: '-',
                  endMeasuringValue: '-',
                  quantity: '-',
                })
                continue
              }
              for (let j = 0; j < energy.measuringBasic.length; j++) {
                let row = {
                  name: name,
                  measureId: '-',
                  startTime: '-',
                  startMeasuringValue: '-',
                  endTime: '-',
                  endMeasuringValue: '-',
                  quantity: '-',
                }
                const measuringItem = energy.measuringBasic[j];
                row.measureId = measuringItem.measureId || '-'
                row.startTime = measuringItem.startTime || '-'
                row.startMeasuringValue = this.judgeNumber(measuringItem.startMeasuringValue)
                row.endTime = measuringItem.endTime || '-'
                row.endMeasuringValue = this.judgeNumber(measuringItem.endMeasuringValue)
                row.quantity = this.judgeNumber(measuringItem.quantity)
                tableData.push(row)
              }
            }
            else {
              tableData.push({
                name: name,
                measureId: '-',
                startTime: '-',
                startMeasuringValue: '-',
                endTime: '-',
                endMeasuringValue: '-',
                quantity: '-',
              })
            }
          }
        }

        this.totalTableData = tableData
      })


    },
    /**
     * 保留两位小数。null显示 -
     */
    judgeNumber (val) {
      if (typeof val === 'number' && !isNaN(val)) {
        return val.toFixed(2)
      }
      return '-'
    },
    bindExportExc () {
      //表格导出
      let name = '场地抄表'
      exportExcel('table', name, this.selectedDate)
    },
  }
}
</script>

<style lang="scss" scoped>
.warp {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  .warp-content {
    width: 100%;
    height: 100%;
    padding: 10px;
    background: #fff;
    color: #2e3842;
    text-align: left;
    box-sizing: border-box;
    display: flex;
    .left {
      flex: 0 0 200px;
      overflow: auto;
      display: flex;
      flex-flow: column;
    }
    .right {
      margin-left: 10px;
      flex: 1;
      display: flex;
      flex-flow: column;
      overflow: auto;
      .list {
        width: 100%;
        height: 100%;
        overflow: auto;
        .item {
          width: 240px;
          height: 100px;
          border-radius: 4px;
          border: 1px solid #eee;
          float: left;
          margin-right: 10px;
          margin-bottom: 10px;
          .btn {
            height: 30px;
            background: #eee;
            line-height: 30px;
            text-align: center;
            cursor: pointer;
            border-radius: 0px 0px 4px 4px;
            &:hover {
              background: #409eff;
              color: #fff;
            }
          }
        }
      }
    }
    .chunk-title {
      flex: 0 0 30px;
      line-height: 30px;
      margin-bottom: 10px;
    }
    .flex-1 {
      flex: 1;
      overflow: auto;
    }
    .flex {
      display: flex;
      align-items: center;
      height: 30px;
      overflow: auto;
    }
    .flex-60 {
      flex: 0 0 70px;
      text-align: right;
    }
    .break-space {
      width: 100%;
      overflow: hidden;
      white-space: break-spaces;
    }
  }
}
</style>